export { default } from './FaqsBlock'
